export default __webpack_public_path__ + "static/0059-8c50e5062f6b3a3b87c4db9fe963ee52.png";